import { MdOutlineDeleteOutline } from "react-icons/md";
import { FormattedMessage, useIntl } from "react-intl";
import { Dropdown, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import {
	useGetFinancialRatesQuery,
	useUpdateFinancialRatesMutation,
} from "../../../../api/settingsAPI";
import { RATES_SHIPPING_METHODS_TRANSLATIONS } from "../../../../helpers/constants";
import { TRateEdit, TRatesObject } from "../../../../api/api.types";

import Arrow from "../../../assets/images/arrow.svg";

export type TRatesData = {
	[key: string]: number;
};

const SettingsRates = () => {
	const [shippingRates, setShippingRates] = useState<TRateEdit[]>([]);
	const [ratesToDelete, setRatesToDelete] = useState<number[]>([]);

	console.log("shippingRates", shippingRates);

	const intl = useIntl();

	const { data } = useGetFinancialRatesQuery();

	const [updateFinancialRates] = useUpdateFinancialRatesMutation();

	const { register, handleSubmit, setValue } = useForm<TRatesData>();

	const handleChangeShippingMethod = (id: number, value: string) => {
		setShippingRates((prevRates) =>
			prevRates.map((rate) =>
				rate.id === id ? { ...rate, shipping_method: value } : rate
			)
		);
	};

	const handleRemoveShippingRate = (id: number) => {
		setShippingRates((prevRates) =>
			prevRates.filter((rate) => rate.id !== id)
		);
		setRatesToDelete((prevRates) => [...prevRates, id]);
	};

	const handleAddNewRow = () => {
		const newRowId = shippingRates.length
			? Math.max(...shippingRates.map((rate) => rate.id)) + 1
			: 1;

		const newRow: TRateEdit = {
			id: newRowId,
			shipping_method: "Standard",
			min_weight: null,
			max_weight: null,
			cost: null,
			cost_int: 0,
			weight_demension: "lb",
		};

		setShippingRates((prevRates) => [newRow, ...prevRates]);
	};

	const onSubmit = (formData: TRatesData) => {
		const updatedData: TRatesObject[] = [];

		if (shippingRates && shippingRates.length > 0) {
			let hasEmptyFields = false;

			shippingRates.forEach((rate) => {
				const minWeight = formData[`min_weight_${rate.id}`];
				const maxWeight = formData[`max_weight_${rate.id}`];
				const cost = formData[`cost_${rate.id}`];

				if (
					String(minWeight) === "" ||
					String(maxWeight) === "" ||
					String(cost) === ""
				) {
					hasEmptyFields = true;
					return;
				}

				updatedData.push({
					...rate,
					min_weight: Number(minWeight),
					max_weight: Number(maxWeight),
					cost: Number(cost) * 100,
				});
			});

			if (hasEmptyFields) {
				toast.error(
					intl.formatMessage({
						id: "someOfTheShippingRatesFieldsAreMissingPleaseFillInAllFields",
					})
				);
				return;
			}

			updateFinancialRates({
				shipping_rates_json: updatedData,
				delete_shipping_rates: ratesToDelete,
			}).then((res) => {
				if ("error" in res) {
					const status = (res.error as { status: number }).status;

					if (status !== 403) {
						toast.error(
							intl.formatMessage({ id: "somethingWentWrong" })
						);
					}
				} else {
					setRatesToDelete([]);
					toast.success(
						intl.formatMessage({
							id: "shippingRatesHaveBeenUpdated",
						})
					);
				}
			});
		}
	};

	useEffect(() => {
		if (data && data.length > 0) {
			setShippingRates(data[0].shipping_rates_json);
		}
	}, [data]);

	useEffect(() => {
		if (shippingRates && shippingRates.length > 0) {
			shippingRates.forEach((rate) => {
				if (rate.min_weight !== null) {
					setValue(`min_weight_${rate.id}`, rate.min_weight);
				}
				if (rate.max_weight !== null) {
					setValue(`max_weight_${rate.id}`, rate.max_weight);
				}
				if (rate.cost !== null) {
					setValue(`cost_${rate.id}`, rate.cost / 100);
				}
			});
		}
	}, [shippingRates, setValue]);

	return (
		<div className="settings-users__block">
			<Form
				className="settings-users__block-body"
				onSubmit={handleSubmit(onSubmit)}
			>
				<div className="settings-users__block-body-header">
					<h5 className="settings-users__block-title">
						<FormattedMessage id="shippingRates" />
					</h5>
					<div className="settings-users__block-body-header-buttons">
						<button
							onClick={handleAddNewRow}
							className="secondary-button"
							type="button"
						>
							<FormattedMessage id="addNewRate" />
						</button>
						<button
							data-testid="save-changes"
							type="submit"
							className="ice-button"
						>
							<FormattedMessage id="saveChanges" />
						</button>
					</div>
				</div>
				<div className="default-table-no-wrapper">
					<table className="table">
						<thead className="thead-light">
							<tr>
								<th>
									<FormattedMessage id="shippingMethod" />
								</th>
								<th>
									<FormattedMessage id="minWeight" /> (lb)
								</th>
								<th>
									<FormattedMessage id="maxWeight" /> (lb)
								</th>
								<th>
									<FormattedMessage id="cost" />
								</th>
								<th></th>
							</tr>
						</thead>
						<tbody className="rates-table-body">
							{shippingRates &&
								shippingRates.length > 0 &&
								shippingRates.map((rate) => (
									<tr key={rate.id}>
										<td className="text-center">
											<Dropdown className="w-100 nav-item">
												<Dropdown.Toggle
													className="user-header-dropdown default-dropdown-toggle p-0 w-100"
													id="dropdown-basic"
												>
													<div
														className="default-dropdown-button"
														style={{
															borderColor:
																"#d9d9d9",
															justifyContent:
																"space-between",
														}}
													>
														{intl.formatMessage({
															id: RATES_SHIPPING_METHODS_TRANSLATIONS[
																rate.shipping_method as keyof typeof RATES_SHIPPING_METHODS_TRANSLATIONS
															],
														})}
														<img
															className="arrow-icon"
															src={Arrow}
															alt=""
														/>
													</div>
												</Dropdown.Toggle>
												<Dropdown.Menu className="default-dropdown-menu-wrapper">
													<div className="default-dropdown-menu">
														<Dropdown.Item
															onClick={() =>
																handleChangeShippingMethod(
																	rate.id,
																	"Standard"
																)
															}
															className="default-dropdown-item"
														>
															<FormattedMessage id="standard" />
														</Dropdown.Item>
														<Dropdown.Item
															onClick={() =>
																handleChangeShippingMethod(
																	rate.id,
																	"Priority"
																)
															}
															className="default-dropdown-item"
														>
															<FormattedMessage id="priority" />
														</Dropdown.Item>
														<Dropdown.Item
															onClick={() =>
																handleChangeShippingMethod(
																	rate.id,
																	"Expedited"
																)
															}
															className="default-dropdown-item"
														>
															<FormattedMessage id="expedited" />
														</Dropdown.Item>
													</div>
												</Dropdown.Menu>
											</Dropdown>
										</td>
										<td className="text-center">
											<Form.Group>
												<Form.Control
													className="default-input"
													type="number"
													data-testid="min-weight"
													placeholder={`${intl.formatMessage(
														{
															id: "minWeight",
														}
													)}`}
													{...register(
														`min_weight_${rate.id}`
													)}
												/>
											</Form.Group>
										</td>
										<td className="text-center">
											<Form.Group>
												<Form.Control
													className="default-input"
													type="number"
													data-testid="max-weight"
													placeholder={`${intl.formatMessage(
														{
															id: "maxWeight",
														}
													)}`}
													{...register(
														`max_weight_${rate.id}`
													)}
												/>
											</Form.Group>
										</td>
										<td className="text-center">
											<Form.Group>
												<Form.Control
													className="default-input"
													type="number"
													data-testid="cost"
													placeholder={`${intl.formatMessage(
														{
															id: "cost",
														}
													)}`}
													{...register(
														`cost_${rate.id}`
													)}
												/>
											</Form.Group>
										</td>
										<td className="text-center">
											<div
												onClick={() =>
													handleRemoveShippingRate(
														rate.id
													)
												}
												className="d-flex align-items-center justify-content-between w-100"
											>
												<MdOutlineDeleteOutline
													className="cursor-pointer"
													size={28}
													color="red"
												/>
											</div>
										</td>
									</tr>
								))}
						</tbody>
					</table>
				</div>
			</Form>
		</div>
	);
};

export default SettingsRates;
